<template>
  <div
    :class="[
      'trial-figure',
      `size-${size}`,
      `color-${color}`,
      cursorPointer && 'cursor',
    ]"
  >
    <span
      :class="[
        'text',
        'text_light',
        'trial-figure-title',
        `size-${size}`,
      ]"
    >{{ title }}</span>
  </div>
</template>

<script>


const COLORS = {
  ORANGE: 'orange',
  BLUE: 'blue',
};

const SIZES = {
  DEFAULT: 'default',
  LARGE: 'large',
};


export default {
  name: 'TTrialFigure',
  props: {
    title: {
      type: String,
      default: null,
    },
    size: {
      type: String,
      default: SIZES.DEFAULT,
      validator(value) {
        return Object.values(SIZES).includes(value);
      },
    },
    color: {
      type: String,
      default: COLORS.ORANGE,
      validator(value) {
        return Object.values(COLORS).includes(value);
      },
    },
    cursorPointer: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style
  lang="scss"
  scoped
>
.trial-figure {
  display: flex;
  justify-content: center;
  align-items: center;
  mask: url("~@/assets/icons/optimized/trial.svg");
  mask-repeat: no-repeat;
  mask-position: center bottom;
  mask-size: cover;
  transform: rotate(-6.45deg);

  &.cursor {
    cursor: pointer;
  }

  &.size {
    &-default {
      height: 53px;
      width: 53px;
    }

    &-large {
      height: 78px;
      width: 78px;
    }
  }

  &.color {
    &-orange {
      background-color: var(--orange);
    }

    &-blue {
      background-color: var(--blue);
    }
  }
}

.trial-figure-title {
  padding: 4px 8px;
  text-align: center;


  &.size {
    &-default {
      font-size: 12px;
      line-height: 15px;
    }

    &-large {
      font-size: 15px;
      line-height: 18px;
    }
  }
}
</style>
